import { createFileRoute, Outlet } from '@tanstack/react-router';
import { ChatLayout } from '~/features/team-chat/ChatLayout';

/**
 * Team chat, laid out like Slack: the chats on the left, the open one in the
 * middle (`/chat/:id`), details on the right when asked for. On a phone the
 * list and the conversation take turns at full width.
 */
export const Route = createFileRoute('/_app/chat')({
  component: () => (
    <ChatLayout>
      <Outlet />
    </ChatLayout>
  ),
});
